import * as React from "react";
import { format, parseISO, isValid } from "date-fns";
import { CalendarIcon } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Calendar } from "@/components/ui/calendar";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { cn } from "@/lib/utils";

// Replaces native <input type="date"> (which always renders in the browser's
// OS/locale format, e.g. MM/DD/YYYY on en-US) with a shadcn Calendar popover
// that always displays and types dd/MM/yyyy, regardless of browser locale.
// Value in/out stays an ISO "YYYY-MM-DD" string so it's a drop-in replacement
// for existing state wired to native date inputs.
export function DatePickerInput({ value, onChange, placeholder = "dd/mm/yyyy", className, disabled, title, minDate, maxDate, "data-testid": testId }) {
  const parsed = value ? parseISO(value) : null;
  const display = parsed && isValid(parsed) ? format(parsed, "dd/MM/yyyy") : "";
  const min = minDate ? parseISO(minDate) : undefined;
  const max = maxDate ? parseISO(maxDate) : undefined;

  return (
    <Popover>
      <PopoverTrigger asChild>
        <Button
          type="button"
          variant="outline"
          disabled={disabled}
          title={title}
          data-testid={testId}
          className={cn(
            "h-8 w-full justify-start gap-2 border-slate-300 text-xs font-normal",
            !display && "text-slate-400",
            className,
          )}
        >
          <CalendarIcon size={13} className="shrink-0 text-slate-400" />
          {display || placeholder}
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-auto p-0" align="start">
        <Calendar
          mode="single"
          selected={parsed && isValid(parsed) ? parsed : undefined}
          onSelect={(d) => d && onChange(format(d, "yyyy-MM-dd"))}
          disabled={(day) => (min && day < min) || (max && day > max)}
          initialFocus
        />
      </PopoverContent>
    </Popover>
  );
}
